import { render, staticRenderFns } from "./EditEventSection.vue?vue&type=template&id=2cb69abb"
import script from "./EditEventSection.vue?vue&type=script&lang=js"
export * from "./EditEventSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports